<template>
    <div class="position-box">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title" v-html="$t('newReg.yhxy')"></div>
        </div>
        <div class="cotainer">
            <div class="cont" v-html="cont"></div>
        </div>
    </div>
</template>

<script>
export default {
  name: "userAgreement",
  data() {
    return {
      lang: "en",
      theme: false,
      cont: ''
    };
  },
  created() {
    this.lang = localStorage.getItem("language") || "en";
    this.theme = JSON.parse(localStorage.getItem("theme"));
  },
  mounted() {
    this.getAbout()
  },
  methods: {
    back() {
      this.$router.push("/reg");
    },
    getAbout(){
        let params = {
            type:'xieyi'
        }
        this.$ajax.get('/web/getTextsList',{params}).then((res) => {
            let resData = res.data.data;
            this.cont = this.contHtml(resData.content);
        }).catch(function(err){
            console.log(err)
        })
    },
    contHtml(str){
        str = str.replace(/&amp;/g, '&');
        str = str.replace(/&lt;/g, '<');
        str = str.replace(/&gt;/g, '>');
        str = str.replace(/&quot;/g, "''");
        str = str.replace(/&#039;/g, "'");
        return str;
    },
  }
};
</script>
<style scoped>
.head {
  position: fixed;
  top: 0;
  width: 100%;
  height: 1.6rem;
  padding: 0 0.44rem;
  color: #000;
  line-height: 1.6rem;
  background: #fff;
  box-sizing: border-box;
  text-align: center;
}
.head .back {
  position: absolute;
  left: 0.3rem;
  top: 50%;
  width: 0.5rem;
  margin-top: -0.4rem;
}
.head .title {
  font-size: 0.56rem;
}
.head .text {
  font-size: 0.48rem;
}
.cotainer {
  position: absolute;
  top: 1.6rem;
  bottom: 0;
  width: 100%;
  background: #f9f9f9;
  overflow-y: scroll;
}
.cotainer .cont {
  padding: 0.3rem;
  color: #7f7f7f;
  font-size: 0.42rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/userAgreement.vue